import Equipment from '../../models/Equipment';
import { ROUTES } from '../../../../config/routes';
import translations from './locales';

const xd42iii = new Equipment({
  id: 'xd42iii',
  name: 'XD42/45III',
  displayName: { main: 'XD42/45', accent: 'III' },
  path: ROUTES.xd42iiiIntro,
  assetDirectory: '/Equipment/xd42iii',
  translations,
  image: { file: 'machine.png', width: 7810, height: 4694 },
  video: { file: 'introduction.mp4', poster: 'video-poster.jpg' },
  catalog: {
    fallbackLanguage: 'en',
    files: { ko: 'catalog.png', en: 'catalog-en.png', zh: 'catalog-zh.png' },
  },
  badges: [
    { id: 'diameter', valueKey: 'diameterTag' },
    { id: 'spindle', value: '6,000 rpm' },
  ],
  metrics: [
    { id: 'diameter', labelKey: 'diameterTag', value: 'Ø42 / Ø45', unit: 'mm' },
    { id: 'spindle', labelKey: 'specifications.mainSpindle.label', value: '6,000', unit: 'rpm' },
    { id: 'stroke', labelKey: 'guideBushStroke', value: '320', unit: 'mm' },
    { id: 'cross', labelKey: 'crossPower', value: '2.2', unit: 'kW' },
  ],
  features: ['rigidity', 'guideBush', 'cross', 'backTools'],
  specifications: [
    { id: 'nc', value: 'Fanuc 0i-TF Plus' },
    { id: 'maxDiameter', value: 'XD42: Ø42 mm / XD45: Ø45 mm (N-TYPE)' },
    { id: 'z1Stroke' },
    { id: 'mainSpindle', value: '6,000 rpm · 5.5 / 7.5 kW' },
    { id: 'turningTools', value: '5 × (□20 mm)' },
    { id: 'frontTools', value: '5 × (ER20M)' },
    { id: 'crossTools', value: 'ER20 × 3 + ER16 × 2' },
    { id: 'crossSpeed', value: '6,000 rpm / 2.2 kW' },
    { id: 'subSpindle', value: '6,000 rpm · 2.2 / 5.5 kW' },
    { id: 'backTools', value: 'Y2: 8 × (ER20)' },
    { id: 'backSpeed', value: '6,000 rpm / 1.0 kW' },
    { id: 'dimensions', value: '2,690 × 1,870 × 1,820 mm' },
    { id: 'weight', value: '4,900 kg' },
    { id: 'power' },
    { id: 'air', value: '120–150 L/min' },
  ],
  specificationNoteKey: 'powerNote',
  options: ['backSix', 'backCross', 'backDrivenEight', 'offCenter', 'crossDriven', 'crossAngle'],
  optionImages: {
    backSix: 'backSix-catalog.jpg',
    backCross: 'backCross-catalog.png',
    backDrivenEight: 'backEight.png',
  },
});

export default xd42iii;
